import type { Flags } from '@/helpers/configCat'
import { getEnv } from '@/helpers/environment'

/**
 * Membership features (like links to /membership) only show if membership is enabled.
 *
 * Membership can be enabled by configuring either;
 *
 * - web.membership_event_id,
 * - web.external_urls.membership, or
 * - both
 *
 * If an external membership URL has been configured, then the /membership route handler will redirect to that, even if
 * membership_event_id has _not_ been configured.
 *
 * External membership URLs may be used to link membership-buyers to a marketing page that links back to Ticketure.
 * In this case membership_event_id should also be set.
 *
 * External membership URLs may also be used to link to an external system (e.g. Salesforce Experience Cloud)
 * where memberships are managed entirely outside of Ticketure. In this case membership_event_id should not be set.
 */
export function isMembershipEnabled(flags: Flags): boolean {
  if (!flags.hide_membership_links) return true

  const external = getEnv().config?.web?.external_urls?.membership
  if (external && external != '') {
    return true
  }

  return isInternalMembershipEnabled(flags)
}

export function isInternalMembershipEnabled(flags: Flags): boolean {
  if (!flags.hide_membership_links) return true

  const config = getEnv().config?.web?.membership_event_id
  return config != null && config != ''
}
